<!--<div class="p-6">
  <h2 class="text-2xl font-bold mb-4">Our Products</h2>

  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
    <div *ngFor="let product of products" class="bg-white shadow rounded-xl p-4">
      <a [routerLink]="['/product', product.id]" class="block border rounded-lg hover:shadow-lg">
        <img [src]="product.imagePath" alt="{{ product.name }}" class="h-48 w-full object-cover rounded-md mb-4">
        <div class="p-4">
          <h2 class="text-lg font-semibold">{{ product.name }}</h2>
          <p class="text-gray-600">৳ {{ product.price }}</p>
        </div>
      </a>
    </div>
  </div>-->

<div class="min-h-screen flex flex-col">

  <!-- Top Search Bar -->
  <div class="bg-white shadow p-4 flex items-center">
    <input type="text"
           placeholder="Search Products by Titles or Tags"
           class="flex-1 border rounded-l px-4 py-2 focus:outline-none"
           [(ngModel)]="searchText">
    <button class="bg-gray-800 text-white px-4 py-2 rounded-r hover:bg-gray-900">
      🔍
    </button>
  </div>

  <!-- Main Content -->
  <div class="flex flex-1 overflow-hidden">

    <!-- Left Sidebar: Category Tree -->
    <div class="w-64 bg-gray-50 border-r overflow-y-auto p-4">
      <h2 class="font-bold mb-4">Shop by Category</h2>
      <app-category-sidebar [categories]="categories"
                            (categorySelected)="loadProducts($event)">
      </app-category-sidebar>
    </div>

    <!-- Right Content: Products -->
    <div class="flex-1 overflow-y-auto p-4">
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        <div *ngFor="let product of filteredProducts()" class="bg-white shadow rounded overflow-hidden flex flex-col">
          <div class="p-4 flex-1 flex flex-col justify-between">
            <a [routerLink]="['/admin/product', product.id]" class="block border rounded-lg hover:shadow-lg">
              <div class="relative">
                <img [src]="environment.apiBaseUrl+product.imagePath" alt="{{ product.name }}" class="w-full h-64 object-cover">
                <!--<span *ngIf="product.isOnSale" class="absolute top-2 right-2 bg-red-600 text-white px-2 py-1 text-xs rounded">SALE</span>-->
              </div>
              <div>
                <h3 class="font-semibold text-sm mb-2">{{ product.name }}</h3>
                <div class="text-center text-sm mb-1">
                  <span class="text-gray-500 line-through" *ngIf="product.price">{{ product.price | currency:'BDT' }}</span>
                  <span class="font-bold ml-1">{{ product.price | currency:'BDT' }}</span>
                </div>
              </div>
            </a>
            <button class="bg-gray-800 hover:bg-gray-900 text-white text-sm py-2 mt-2 rounded w-full">
              🛒 Buy Now
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
